<template>
    <transition-group tag="div" name="slide" class="campus-events__list">
        <CampusEvent
            v-for="(campusEvent, x) in filteredEvents" 
            :key="'cx'+x"
            :event="campusEvent"
            :isActive="activeEvent && activeEvent.campusEventId === campusEvent.campusEventId"
        />
        <div class="campus-events__notice" key="cxl" v-if="!filteredEvents || filteredEvents.length < 1">
            <p v-if="hasFetched">
                No events have been found.
            </p>
            <p v-else>
                Loading campus events...
            </p>
        </div>
    </transition-group>
</template>

<script>
import {mapState} from "vuex";
import CampusEvent from "@/components/CampusResources/CampusEvents/CampusEvent";
import EventFilter from "@/services/EventFilter";
import EventSlugManager from "@/services/EventSlugManager";

export default {
    name: "CampusEventsList",
    components: {CampusEvent},
    data: () => ({ 
        hasFetched: false,
    }),
    watch: {

        filteredEvents() {
            this.hasFetched = true
        },
        
    },
    computed: {

        eventSlug() {
            return this.$route.params.event
        },

        activeEvent() {
            return EventSlugManager.findBySlug(this.events, this.eventSlug)
        },

        filteredEvents() {
            let events = [...this.events]
            events = EventFilter.filter(events, this.filters)

            return EventFilter.sort(events, this.sort)
        },

        ...mapState({
            events: state => state.campus.events,
            provinces: state => state.campus.provinces,
            filters: state => state.campus.filters,
            sort: state => state.campus.sort
        })

    }
}
</script>
